import React, {Component} from 'react';
import 'index.css';
import './Controls.css';
import './FullScreenBtn.scss';

class FullScreenBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullscreen: false,
    };
    this.handleFullscreenChange = this.handleFullscreenChange.bind(this);
    this.toggleFullScreen = this.toggleFullScreen.bind(this);
  }
  handleFullscreenChange() {
    if (document.fullscreen) {
      this.setState({fullscreen: true});
    } else {
      this.setState({fullscreen: false});
      this.props.onExitfullscreen && this.props.onExitfullscreen();
    }
  }
  componentDidMount() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
  }
  componentWillUnmount() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
  }
  toggleFullScreen(e) {
    e.stopPropagation();
    if (document.fullscreenElement || document.webkitFullscreenElement) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    } else {
      if (this.props?.onFullScreen) {
        this.props.onFullScreen();
      }
      if (this.props.node.requestFullscreen) this.props.node.requestFullscreen();
      else if (this.props.node.webkitRequestFullscreen) this.props.node.webkitRequestFullscreen();
    }
  }
  render() {
    let btnClass = 'controls-fullscreen-btn controls-btn';
    if (this.state.fullscreen) {
      btnClass += ' fullscreen';
    }
    return (
      <span className={btnClass} onClick={this.toggleFullScreen}>
        <svg
          className="controls-fullscreen-off"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
          title="Fullscreen"
        >
          <path d="M 2,9 H 0 v 5 H 5 V 12 H 2 Z M 0,5 H 2 V 2 H 5 V 0 H 0 Z m 12,7 H 9 v 2 h 5 V 9 H 12 Z M 9,0 v 2 h 3 v 3 h 2 V 0 Z"></path>
        </svg>
        <svg
          className="controls-fullscreen-on"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14 14"
          title="FullscreenExit"
        >
          <path d="m 0,11 h 3 v 3 H 5 V 9 H 0 Z M 3,3 H 0 V 5 H 5 V 0 H 3 Z m 6,11 h 2 v -3 h 3 V 9 H 9 Z M 11,3 V 0 H 9 v 5 h 5 V 3 Z"></path>
        </svg>
      </span>
    );
  }
}
export default FullScreenBtn;
